import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services';
import { Permission } from '../models/permission.model';
import { NO_ACCESS_ROUTE } from '../constants';

export const hasPermission = (target: Permission[]): CanActivateFn => {
  return () => {
    const hasAccess = inject(AuthService).hasPermission(target);
    return hasAccess ? true : inject(Router).parseUrl(NO_ACCESS_ROUTE);
  };
};
